




// import React, { useState, useEffect } from 'react';

// const LearningPathTFD = () => {
//     const [toggle, setToggle] = useState(null);
//     const [nestedToggle, setNestedToggle] = useState({});
//     const [data, setData] = useState([]);

//     const updateToggle = (id) => {
//         setToggle(toggle === id ? null : id);
//     };

//     const updateNestedToggle = (nestedId) => {
//         setNestedToggle((prevState) => ({
//             ...prevState,
//             [nestedId]: !prevState[nestedId],
//         }));
//     };

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await fetch('your-api-url');
//                 const data = await response.json();
//                 setData(data); // Update the state with fetched data
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//         };
//         fetchData();
//     }, []);

//     const listContent = [
//         {
//             id: 1,
//             title: " INDUSTRIAL REVOLUTIONS AND THEIR IMPACT",
//             content: null,
//             nestedContent: [],
//         },
//         {
//                         id: 1,
//                         title: "The 1st Industrial Revolution: Mechanization and Steam Power ",
//                         content: null,
//                         nestedContent: [
//                             {
//                                 id: 1,
//                                 text: "•		Key Innovations  ",
//                                 dummyText: ["*		Mechanization: Introduction of machines in manufacturing.","*		Steam Engine: Development of steam-powered engines by James Watt."	],
//                             },
//                             { 
//                                 id: 2,
//                                 text: "•		 Impact ",
//                                 dummyText: ["*					Growth of the textile industry through mechanized production.", "*				Introduction of steam-powered trains and ships for efficient transportation", "*		Urbanization: Migration from rural to urban areas for factory work.",],
//                             },
                            
//                              {
//                                 id: 3,
//                                  text: "• Relevance to Engineers: ",
//                                  dummyText: ["*	`	Introduction of mechanical engineering concepts like gears, levers, and power systems.","*		Basics of thermodynamics applied in steam engines.","*Case Example: The role of the steam engine in revolutionizing textile production"],
//                              },
                            
//                         ],
//                     },
//                     {
//                         id: 2,
//                         title: " The 2nd Industrial Revolution: Mass Production and Electrification  ",
                        
//                         nestedContent: [
//                             {
//                                 id: 1,
//                                 text: "•	 	Key Innovations: ",
//                                 dummyText: ["*				Mass Production: Introduction of assembly lines (e.g., Henry Ford's automobile manufacturing).", "*	Electrification: Use of electricity for factories, homes, and cities.",],
//                             },
//                             {
//                                 id: 2,
//                                 text: "•	 	Impact",
//                                 dummyText: ["*	Growth of industries like automobiles, steel, and chemical manufacturing.","*•	Improved urban infrastructure with power grids and telecommunication.","*	Increased affordability and availability of consumer goods."],
//                             },
//                             {
//                                 id: 3,
//                                 text: "•	 	Discussion Activity: ",
//                                 dummyText: ["*			Analyse how Henry Ford's assembly line changed production efficiency",],
//                             },
                           
                            
//                         ],
//                     },
//                     {
//                         id: 3,
//                         title: "The 3rd Industrial Revolution: Digital Revolution and Automation   ",
                       
//                         nestedContent: [
//                             {
//                                 id: 1,
//                                 text: "•		Key Innovations: ",
//                                 dummyText: ["*				Digital Systems: Shift from analog to digital technologies (computers, software, and communication systems).", "*		Automation: Integration of robotics and programmable systems in manufacturing.", ],
//                             },
//                             {
//                                 id: 2,
//                                 text: "•		Impact:  ",
//                                 dummyText: ["*				Creation of the IT industry and digital communication systems.","*		Increased productivity through robotics and automated processes.","*	Introduction of the internet for global connectivity."],
//                             },
//                             {
//                                 id: 3,
//                                 text: "•		Relevance to Engineers: ",
//                                 dummyText: ["*					Development of computer science, programming, and electronics.","*		•	Use of PLC (Programmable Logic Controllers) in industrial automation.","*Case Example: How automation improved assembly line precision and efficiency in manufacturing."],
//                             },
                            
                           
//                         ],
//                     },
//                     {
//                         id: 4,
//                         title: "The 4th Industrial Revolution: Industry 4.0 and Smart Technologies    ",
//                      dummyText: [,],
            
//                         nestedContent: [
//                             {
//                                 id: 1,
//                                 text: "•		Key Innovations: ",
//                                  dummyText: ["*		Cyber-Physical Systems: Integration of digital and physical processes.","*		Internet of Things (IoT): Smart devices interconnected for real-time data exchange.","*	Artificial Intelligence (AI) and Big Data: Enhanced decision-making and predictive analytics."],
//                             },
//                             {
//                                 id: 2,
//                                 text: "•	 	Impact: ",
//                                 dummyText: ["*					Development of smart factories with real-time monitoring and optimization.","	*	Advancements in healthcare (e.g., personalized medicine) and renewable energy..","*•	Enhanced supply chain management using IoT and AI."],
//                             },
//                             {
//                                 id: 3,
//                                 text: "•	 	Relevance to Engineers:",
//                                 dummyText: ["*						Importance of IoT, AI, and data analysis for modern engineering solutions.","	*		Role of engineers in designing sustainable and smart systems.",],
//                             },
//                             {
//                                 id: 4,
//                                 text: "•	 	Interactive Discussion: ",
//                                 dummyText: ["*						Discuss key technologies of Industry 4.0 (IoT, AI, robotics) and their impact on ","	*		Future Trends: Overview of 5G, 3D printing, and renewable energy innovations.",],
//                             },
//                         ],
//                     },
                    
                   
//                 ];

//     return (
//         <div className="container my-5">
//             <h2
//                 className="fw-bold mb-4"
//                 style={{
//                     color: "#000",
//                     fontFamily: "Roboto",
//                     width: "100%",
//                     textAlign: "center",
//                     marginTop: "-30px",
//                 }}
//             >
//                 PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
//             </h2>

//             <div className="list-tab" style={{ width: "100%", padding: 0 }}>
//                 {listContent.map(({ id, title, content, nestedContent }, index) => (
//                     <div key={id} className="mb-3" style={{ width: "100%" }}>
//                         <div
//                             className={`p-3 rounded cursor-pointer d-flex justify-content-between align-items-center ${
//                                 index === 0 ? "bg-white" : "bg-light"
//                             }`}
//                             onClick={() => index !== 0 && updateToggle(id)}
//                             style={{
//                                 boxShadow: index === 0 ? "none" : "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                                 width: "100%", 
//                                 cursor: index === 0 ? "default" : "pointer",
//                             }}
//                         >
//                             <span
//                                 className={`fw-bold`}
//                                 style={{
//                                     fontFamily: "Roboto",
//                                     fontSize: index === 0 ? "19px" : "20px",
//                                     color: index === 0 ? "#0072FF" : undefined,
//                                 }}
//                             >
//                                 {title}
//                             </span>
//                             {index !== 0 && (
//                                 <span style={{ fontSize: "20px" }}>
//                                     {toggle === id ? "-" : "+"}
//                                 </span>
//                             )}
//                         </div>
//                         {/* Add line below first item */}
//                         {/* {index === 0 && (
//                             <div
//                                 style={{
//                                     height: "1px",
//                                     backgroundColor: "orange",
//                                     width: "20%",
//                                      margin: "-13px",
//                                      marginLeft: '50px',
//                                 }}
//                             ></div>
//                         )} */}
//                         {toggle === id && index !== 0 && (
//                             <div className="mt-2 px-4">
//                                 {content && <p style={{ fontFamily: "Roboto" }}>{content}</p>}
//                                 {nestedContent.map(({ id: nestedId, text, dummyText }) => (
//                                     <div key={nestedId} className="my-2">
//                                         <div
//                                             className="p-2 bg-white rounded cursor-pointer d-flex justify-content-between align-items-center"
//                                             onClick={() => updateNestedToggle(nestedId)}
//                                             style={{ border: "1px solid #ddd" }}
//                                         >
//                                             <span
//                                                 style={{
//                                                     fontFamily: "Roboto",
//                                                     fontSize: "18px",
//                                                 }}
//                                             >
//                                                 {text}
//                                             </span>
//                                             <span style={{ fontSize: "18px" }}>
//                                                 {nestedToggle[nestedId] ? "-" : "+"}
//                                             </span>
//                                         </div>
//                                         {nestedToggle[nestedId] && (
//                                             <div className="mt-2 px-3">
//                                                 <ul
//                                                     style={{
//                                                         fontFamily: "Roboto",
//                                                         color: "#555",
//                                                     }}
//                                                 >
//                                                     {dummyText.map((item, index) => (
//                                                         <li key={index}>{item}</li>
//                                                     ))}
//                                                 </ul>
//                                             </div>
//                                         )}
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default LearningPathTFD;




// import React, { useState } from 'react';

// const LearningPathTFD = () => {
//     const [toggle, setToggle] = useState(null);
//     const [nestedToggle, setNestedToggle] = useState({});
//     const [hideOthers, setHideOthers] = useState(false);

//     const updateToggle = (id) => {
//         if (id === 1) {
//             // Toggle first item
//             setHideOthers(!hideOthers);
//             setToggle(null); // Reset nested toggles
//             setNestedToggle({});
//         } else {
//             setToggle(toggle === id ? null : id);
//         }
//     };

//     const updateNestedToggle = (nestedId) => {
//         setNestedToggle((prev) => ({
//             ...prev,
//             [nestedId]: !prev[nestedId],
//         }));
//     };

//     const listContent = [
//         {
//             id: 1,
//             title: "INDUSTRIAL REVOLUTIONS AND THEIR IMPACT",
//             nestedContent: [],
//         },
//         {
//             id: 2,
//             title: "The 1st Industrial Revolution: Mechanization and Steam Power",
//             nestedContent: [
//                 {
//                     id: 1,
//                     text: "• Key Innovations",
//                     dummyText: [
//                         "* Mechanization: Introduction of machines in manufacturing.",
//                         "* Steam Engine: Development of steam-powered engines by James Watt.",
//                     ],
//                 },
//                 {
//                     id: 2,
//                     text: "• Impact",
//                     dummyText: [
//                         "* Growth of the textile industry through mechanized production.",
//                         "* Steam-powered trains and ships.",
//                         "* Urbanization for factory work.",
//                     ],
//                 },
//             ],
//         },
//         {
//             id: 3,
//             title: "The 2nd Industrial Revolution: Mass Production and Electrification",
//             nestedContent: [
//                 {
//                     id: 1,
//                     text: "• Key Innovations",
//                     dummyText: [
//                         "* Assembly lines (e.g., Henry Ford).",
//                         "* Electrification of factories, homes.",
//                     ],
//                 },
//                 {
//                     id: 2,
//                     text: "• Impact",
//                     dummyText: [
//                         "* Automobile and steel industries.",
//                         "* Power grids and telecom.",
//                     ],
//                 },
//             ],
//         },
//         {
//             id: 4,
//             title: "The 3rd Industrial Revolution: Digital Revolution and Automation",
//             nestedContent: [
//                 {
//                     id: 1,
//                     text: "• Key Innovations",
//                     dummyText: [
//                         "* Digital technologies: Computers, software.",
//                         "* Robotics and automation.",
//                     ],
//                 },
//                 {
//                     id: 2,
//                     text: "• Impact",
//                     dummyText: [
//                         "* IT industry and internet.",
//                         "* Increased productivity through automation.",
//                     ],
//                 },
//             ],
//         },
//     ];

//     return (
//         <div className="container my-5">
//             <h2
//                 className="fw-bold mb-4"
//                 style={{
//                     color: "#000",
//                     fontFamily: "Roboto",
//                     textAlign: "center",
//                     marginTop: "-50px",
//                 }}
//             >
//                 PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
//             </h2>

//             <div className="list-tab" style={{ width: "100%" }}>
//                 {listContent.map(({ id, title, nestedContent }) => {
//                     if (hideOthers && id !== 1) return null;

//                     return (
//                         <div key={id} className="mb-3">
//                             <div
//                                 className={`p-3 rounded d-flex justify-content-between align-items-center ${id === 1 ? "bg-white" : "bg-light"}`}
//                                 onClick={() => updateToggle(id)}
//                                 style={{
//                                     boxShadow: id === 1 ? "none" : "0px 4px 8px rgba(0,0,0,0.1)",
//                                     cursor: "pointer",
//                                 }}
//                             >
//                                 <span
//                                     className="fw-bold"
//                                     style={{
//                                         fontFamily: "Roboto",
//                                         fontSize: "18px",
//                                         color: id === 1 ? "#0072FF" : "#000",
//                                     }}
//                                 >
//                                     {title}
//                                 </span>
//                                 <span style={{ fontSize: "20px" }}>
//                                     {(id === 1 && hideOthers) || (toggle === id && id !== 1) ? "-" : "+"}
//                                 </span>
//                             </div>

//                             {toggle === id && nestedContent.length > 0 && (
//                                 <div className="mt-2 px-4">
//                                     {nestedContent.map(({ id: nestedId, text, dummyText }) => (
//                                         <div key={nestedId} className="my-2">
//                                             <div
//                                                 className="p-2 bg-white rounded d-flex justify-content-between align-items-center"
//                                                 onClick={() => updateNestedToggle(nestedId)}
//                                                 style={{ border: "1px solid #ddd", cursor: "pointer" }}
//                                             >
//                                                 <span style={{ fontFamily: "Roboto", fontSize: "16px" }}>
//                                                     {text}
//                                                 </span>
//                                                 <span>{nestedToggle[nestedId] ? "-" : "+"}</span>
//                                             </div>
//                                             {nestedToggle[nestedId] && (
//                                                 <div className="mt-2 px-3">
//                                                     <ul style={{ fontFamily: "Roboto", color: "#555" }}>
//                                                         {dummyText.map((item, i) => (
//                                                             <li key={i}>{item}</li>
//                                                         ))}
//                                                     </ul>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     );
//                 })}
//             </div>
//         </div>
//     );
// };

// export default LearningPathTFD;







import React, { useState } from "react";

const LearningPathTFD = () => {
  const [toggleAllSections, setToggleAllSections] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({});
  const [toggleNewModule, setToggleNewModule] = useState(false);
  const [newModuleToggle, setNewModuleToggle] = useState({});
  const [toggleExteraModule, setToggleExteraModule] = useState(false);
  const [exteraModuleToggle, setExteraModuleToggle] = useState({});
  const [toggleIsExteraModule, setToggleIsExteraModule] = useState(false);
  const [isExteraModuleToggle, setIsExteraModuleToggle] = useState({});
  const [toggleAdditionalModule, setToggleAdditionalModule] = useState(false);
  const [additionalModuleToggle, setAdditionalModuleToggle] = useState({});
  const [toggleExtraAdvancedModule, setToggleExtraAdvancedModule] = useState(false);
  const [extraAdvancedModuleToggle, setExtraAdvancedModuleToggle] = useState({});
  const [toggleAndLocalModule, setToggleAndLocalModule]= useState(false);
  const [AndLocalModuleToggle, setAndLocalModuleToggle]= useState({});
  const [toggleAndUlteraLocalModule, setToggleAndUlteraLocalModule]= useState(false);
  const [AndUlteraLocalModuleToggle, setAndUlteraLocalModuleToggle]= useState({});
  const listContent = [
    // Existing sections
    {
      id: 1,
      title: "Key Innovations ",
      nestedContent: [
        { id: 1, text: "• 		Mechanization: Introduction of machines in manufacturing", dummyText: [] },
        { id: 2, text: "•	Steam Engine: Development of steam-powered engines by James Watt.", dummyText: [] },
       
      ],
    },
    {
      id: 2,
      title: "Relevance to Engineers",
      nestedContent: [
        { id: 1, text: "• Introduction of mechanical engineering concepts like gears, levers, and power systems", dummyText: [] },
        { id: 2, text: "• Basics of thermodynamics applied in steam engines", dummyText: [] },
        { id: 3, text: "• 	Case Example: The role of the steam engine in revolutionizing textile production", dummyText: [] },
       
      ],
    },
    {
        id: 3,
        title: "The 2nd Industrial Revolution: Mass Production and Electrification",
        nestedContent: [
          { id: 1, text: "• 	Mass Production: Introduction of assembly lines (e.g., Henry Ford's automobile manufacturing).", dummyText: [] },
          { id: 2, text: "•  	Electrification: Use of electricity for factories, homes, and cities.", dummyText: [] },
         
        ],
      },
      {
        id: 4,
        title: "Impact",
        nestedContent: [
          { id: 1, text: "• Growth of industries like automobiles, steel, and chemical manufacturing.", dummyText: [] },
            { id: 1, text: "• Improved urban infrastructure with power grids and telecommunication.", dummyText: [] },
             { id: 1, text: "• Increased affordability and availability of consumer goods.", dummyText: [] },
         
         
        ],
      },
       {
        id: 5,
        title: "Discussion Activity",
        nestedContent: [
          { id: 1, text: "•Analyse how Henry Ford's assembly line changed production efficiency", dummyText: [] },
            
         
         
        ],
      },

      {
        id: 6,
        title: "The 3rd Industrial Revolution: Digital Revolution and Automation",
        nestedContent: [
          { id: 1, text: "•Analyse how Henry Ford's assembly line changed production efficiency", dummyText: [] },
            
         
         
        ],
      },

      {
        id: 7,
        title: "The 4th Industrial Revolution: Industry 4.0 and Smart Technologies ",
        nestedContent: [
          { id: 1, text: "Cyber-Physical Systems: Integration of digital and physical processes", dummyText: [] },
           { id: 1, text: "Internet of Things (IoT): Smart devices interconnected for real-time data exchange", dummyText: [] },
            { id: 1, text: "Artificial Intelligence (AI) and Big Data: Enhanced decision-making and predictive analytics.", dummyText: [] },
            
         
         
        ],
      },
  ];

  const newModuleContent = [
    // New module sections
    {
      id: 1,
      title1:'Manufacturing Processes',
      title: "  Thermodynamics",
      nestedContent: [
        { id: 1, text: "• 		Laws of Thermodynamics: Overview of the 1st and 2nd laws", dummyText: [""] },
        { id: 2, text: "• 		Heat and Work Interaction: Basics and applications in engineering.", dummyText: [] },
       
      ],
    },
    {
      id: 2,
      title: "  Fluid Mechanics",
      nestedContent: [
        { id: 1, text: "• 		 Properties of Fluids: Viscosity, density, and compressibility.", dummyText: [] },
        { id: 2, text: "• 		Fundamentals of Fluid Statics and Dynamics: Bernoulli’s equation and practical applications..", dummyText: [] },
        { id: 3, text: "• 		Job Opportunities, Roles, and Packages for Fresher", dummyText: [] },
       
      ],
    },
    {
        id: 3,
        title: "  Engineering Mechanics",
        nestedContent: [
          { id: 1, text: "• 		Force Systems and Equilibrium: Basic concepts of statics", dummyText: [] },
          { id: 2, text: "• 		 Kinematics and Kinetics: Motion, velocity, and acceleration.", dummyText: [] },
         
        ],
      },
      {
        id: 4,
        title: " • Strength of Materials",
        nestedContent: [
          { id: 1, text: "• 			Stress and Strain: Elasticity, Hooke’s Law.", dummyText: [] },
           { id: 1, text: "• 			Applications: Basics of buckling, torsion, and structural safety.", dummyText: [] },
         
        ],
      },
      
     
      
  ];

  const exteraModuleContent = [
    // Extra module sections
    {
      id: 3,
      title: " • Casting and Molding",
      nestedContent: [
        { id: 1, text: "• 			 Overview of sand, die, and investment casting.", dummyText: [] },
           { id: 1, text: "• 			Common defects and their impact on quality", dummyText: [] },
              { id: 1, text: "• 			  Welding Processes Introduction to arc, MIG, and TIG welding techniques", dummyText: [] },
       
     
       
      ],
    },
    {
      id: 4,
      title: " Metal Forming Techniques",
      nestedContent: [
        { id: 1, text: "• 			Forging, rolling, and extrusion: Methods and applications.", dummyText: [] },
        { id: 2, text: "• 			Cold vs. Hot Forming: Differences and use cases.", dummyText: [] },
        
        
      ],
    },
    {
        id: 5,
        title: " Material Removal Processes",
        nestedContent: [
          { id: 1, text: "• 		Conventional Methods: Turning, milling, and grinding", dummyText: [] },
          { id: 2, text: "• 	Advanced Techniques: Basics of EDM (Electrical Discharge Machining).", dummyText: [] },
          
        ],
      },
      
  ];

  const additionalModuleContent = [
    // Additional module sections
    {
      id: 5,
      title: "  Design and Drafting",
      nestedContent: [
        { id: 1, text: "•			Mechanical Design Basics: Understanding the design process and factors of safety.", dummyText: [] },
        { id: 2, text: "•			Engineering Drawing: Overview of 2D/3D projections, sectional views, and assembly drawings", dummyText: [] },
      ],
    },
    {
      id: 6,
      title: " Automation and Industrial Processes",
      nestedContent: [
        { id: 1, text: "• 			Understanding Automation: Applications in modern industries", dummyText: [] },
        { id: 2, text: "•			 PLC and CNC Basics: Introduction to programming and their role in precision and efficiency", dummyText: [] },
      ],
    },
    
      
      
  ];

  const isExteraModuleContent = [
    // Additional Module Sections
    {
      id: 7,
      title: " Material Science and Selection",
      nestedContent: [
        { id: 1, text: "• 			Properties of Materials: Mechanical and thermal properties", dummyText: [] },
        { id: 2, text: "• 		Composite Materials: Overview of types and their applications", dummyText: [] },
        { id: 3, text: "• 			 Composite Materials: Overview of types and their applications.", dummyText: [] },
      ],
    },

    {
      id: 8,
      title: "Kinematics of Machinery",
      nestedContent: [
        { id: 1, text: "• 			Introduction to Kinematics: Linkages, joints, and motion types", dummyText: [] },
        { id: 2, text: "• 			Mechanism Design: Automotive wipers, robotic arms, and other case studies.", dummyText: [] },
      ],
    }, 

    
      
  ];

  
  

  

  const toggleSection = (id, module = "existing") => {
    if (module === "existing") {
      setSectionToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "new") {
      setNewModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extera") {
      setExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "isextera") {
      setIsExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "additional") {
      setAdditionalModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extraAdvanced") {
      setExtraAdvancedModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    }else if (module === "andLocal"){
        setAndLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
   } else if (module === "andUlteraLocal"){
    setAndUlteraLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
  }
  };
  
  return (
    <div className="container my-5">
      <h2 className="fw-bold mb-4" style={{ color: "#000", fontFamily: "Roboto", textAlign: "center",marginTop:'-49px', }}>
        PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
      </h2>
      <br />
      
      {/* Existing Module */}
      <div
  className="fw-bold mb-4 p-3 bg-light rounded"
  style={{
    color: "blue",
    fontFamily: "Roboto",
    fontSize: "20px",
    cursor: "pointer",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }}
  onClick={() => setToggleAllSections(!toggleAllSections)}
>
  Introduction To Revolution and their Impact

  {/* <span
    style={{
      display: "inline-block",
      width: "28px",
      height: "28px",
      borderRadius: "50%",
      backgroundColor: "#007bff",
      color: "white",
      fontWeight: "bold",
      fontSize: "18px",
      lineHeight: "28px",
      textAlign: "center"
    }}
  >
    {newModuleToggle[""] ? "−" : "+"}
  </span> */}
</div>

      {toggleAllSections && (
        <div className="list-tab mt-3">
          {listContent.map(({ id, title, nestedContent, }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id)}
              >
                {title}
                <span>{sectionToggle[id] ? "-" : "+"}</span>
              </div>
              {sectionToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* New Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleNewModule(!toggleNewModule)}
      >
      Introduction to mechanical Engineering
      </div>
      

      {toggleNewModule && (
        <div className="list-tab mt-3">
          {newModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "new")}
              >
                {title}
                <span>{newModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {newModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Extera Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExteraModule(!toggleExteraModule)}
      >
       Manufacturing Processes  
      </div>

      {toggleExteraModule && (
        <div className="list-tab mt-3">
          {exteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extera")}
              >
                {title}
                <span>{exteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {exteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Additional Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleAdditionalModule)}
      >
         Mechanical Design and Automation
      </div>

      {toggleAdditionalModule && (
        <div className="list-tab mt-3">
          {additionalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{additionalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {additionalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

<div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleIsExteraModule(!toggleIsExteraModule)}
      >
    Materials and Mechanisms
      </div>

      {toggleIsExteraModule && (
        <div className="list-tab mt-3">
          {isExteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "isextera")}
              >
                {title}
                <span>{isExteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {isExteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {/* Extra Advanced Module */}
      

     

      

     
      
    </div>
  );
};

export default LearningPathTFD;





// import React, { useState } from 'react';

// const LearningPath = () => {
//   const [openModules, setOpenModules] = useState({});
//   const [openTopics, setOpenTopics] = useState({});

//   const toggleModule = (module) => {
//     setOpenModules((prev) => ({ ...prev, [module]: !prev[module] }));
//   };

//   const toggleTopic = (module, topic) => {
//     const key = `${module}-${topic}`;
//     setOpenTopics((prev) => ({ ...prev, [key]: !prev[key] }));
//   };

//   const data = {
//     'Mechanical Engineering': {
//       'CAD Design': ['Introduction to CAD', '2D & 3D Modeling', 'Software Tools (AutoCAD, SolidWorks)'],
//       'Thermodynamics': ['Laws of Thermodynamics', 'Heat Transfer', 'Applications in Engines'],
//       'Mechanics': ['Statics & Dynamics', 'Material Strength', 'Motion & Force Analysis'],
//     },
//     'Electrical Engineering': {
//       'Circuit Theory': ['Basic Circuit Elements', 'Ohm’s Law & Kirchhoff’s Laws', 'AC & DC Circuits'],
//       'Control Systems': ['Open vs Closed Loop', 'Transfer Functions', 'PID Controllers'],
//       'Power Systems': ['Power Generation', 'Transmission & Distribution', 'Smart Grids'],
//     },
//     'Coding & Programming': {
//       'Web Development': ['HTML, CSS Basics', 'React.js & Node.js', 'Building Full Stack Projects'],
//       'Python Programming': ['Syntax & Basics', 'Libraries (NumPy, Pandas)', 'Projects & Applications'],
//       'Data Structures': ['Arrays, Linked Lists', 'Stacks, Queues, Trees', 'Algorithms & Time Complexity'],
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>Learning Path</h2>
//       {Object.entries(data).map(([module, topics]) => (
//         <div key={module} style={styles.moduleBox}>
//           <div
//             style={styles.moduleHeader}
//             onClick={() => toggleModule(module)}
//           >
//             <span>{module}</span>
//             <span>{openModules[module] ? '-' : '+'}</span>
//           </div>

//           {openModules[module] && (
//             <div style={styles.topicContainer}>
//               {Object.entries(topics).map(([topic, subtopics]) => {
//                 const topicKey = `${module}-${topic}`;
//                 return (
//                   <div key={topic} style={styles.topicBox}>
//                     <div
//                       style={styles.topicHeader}
//                       onClick={() => toggleTopic(module, topic)}
//                     >
//                       <span>{topic}</span>
//                       <span>{openTopics[topicKey] ? '-' : '+'}</span>
//                     </div>

//                     {openTopics[topicKey] && (
//                       <ul style={styles.subtopicList}>
//                         {subtopics.map((sub, i) => (
//                           <li key={i} style={styles.subtopicItem}>
//                             {sub}
//                           </li>
//                         ))}
//                       </ul>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// const styles = {
//   container: {
//     maxWidth: '900px',
//     margin: '20px auto',
//     padding: '20px',
//     fontFamily: 'Arial, sans-serif',
//   },
//   heading: {
//     textAlign: 'center',
//     fontSize: '2rem',
//     marginBottom: '30px',
//   },
//   moduleBox: {
//     border: '1px solid #ccc',
//     borderRadius: '12px',
//     marginBottom: '20px',
//     overflow: 'hidden',
//     boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//   },
//   moduleHeader: {
//     background: '#1E88E5',
//     color: '#fff',
//     padding: '16px 20px',
//     fontSize: '1.2rem',
//     fontWeight: 'bold',
//     display: 'flex',
//     justifyContent: 'space-between',
//     cursor: 'pointer',
//   },
//   topicContainer: {
//     padding: '10px 20px',
//     backgroundColor: '#f9f9f9',
//   },
//   topicBox: {
//     marginBottom: '10px',
//   },
//   topicHeader: {
//     background: '#BBDEFB',
//     padding: '10px 14px',
//     fontSize: '1rem',
//     fontWeight: '600',
//     cursor: 'pointer',
//     display: 'flex',
//     justifyContent: 'space-between',
//     borderRadius: '8px',
//   },
//   subtopicList: {
//     listStyleType: 'disc',
//     paddingLeft: '25px',
//     marginTop: '8px',
//     color: '#333',
//   },
//   subtopicItem: {
//     marginBottom: '6px',
//     fontSize: '0.95rem',
//   },
// };

// export default LearningPath;











